import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';

const Header = () => {
  return (
    <Box sx={{ textAlign: 'center', mb: 6 }}>
      <motion.div
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Typography
          variant="h1"
          sx={{
            background: 'linear-gradient(45deg, #00ff9d 30%, #ff0099 90%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 'bold',
            mb: 2
          }}
        >
          Shaaz's YouTube Downloader
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: 'text.secondary',
            maxWidth: '600px',
            mx: 'auto',
            lineHeight: 1.6
          }}
        >
          Download your favorite YouTube videos in the highest quality with this elegant and powerful tool.
        </Typography>
      </motion.div>
    </Box>
  );
};

export default Header; 